export const APPLICANT_TYPE_ICONS = {
    kindergarten: "Baby",
    elementary: "BookOpenText",
    "junior-high": "BookMarked",
    "senior-high": "GraduationCap",
    "college-freshman": "GraduationCap",
    "college-transferee": "Repeat2",
    "als-pept": "Award",
    foreign: "Globe2",
};

export const DEPARTMENT_ICONS = {
    "college-of-criminal-justice-education": "Shield",
    "college-of-computer-studies": "Laptop2",
    "college-of-pharmacy": "Pill",
    "college-of-teacher-education": "SquarePen",
    "college-of-business-education": "Briefcase",
    "college-of-hospitality-and-tourism-management": "UtensilsCrossed",
    "department-of-basic-education": "School2",
};

export const APPLICATION_STATUSES = [
    "Draft", "Submitted", "Documents Pending", "For Initial Review", "Needs Revision",
    "For Assessment", "Qualified", "Accepted", "Waitlisted", "Enrolled", "Closed", "Withdrawn",
];

export const STATUS_TONE = {
    Draft: "bg-neutral-100 text-neutral-700 border-neutral-200",
    Submitted: "bg-emerald-50 text-emerald-800 border-emerald-200",
    "Documents Pending": "bg-amber-50 text-amber-800 border-amber-200",
    "For Initial Review": "bg-sky-50 text-sky-800 border-sky-200",
    "Needs Revision": "bg-rose-50 text-rose-800 border-rose-200",
    "For Assessment": "bg-sky-50 text-sky-800 border-sky-200",
    Qualified: "bg-emerald-50 text-emerald-800 border-emerald-200",
    Accepted: "bg-emerald-100 text-emerald-900 border-emerald-300",
    Waitlisted: "bg-amber-50 text-amber-800 border-amber-200",
    Enrolled: "bg-lnl-green text-white border-lnl-green",
    Closed: "bg-neutral-100 text-neutral-700 border-neutral-200",
    Withdrawn: "bg-neutral-100 text-neutral-700 border-neutral-200",
};
